export interface Suggestion {
  id: string;
  type: 'insight' | 'action' | 'offer';
  title: string;
  description: string;
  icon: string;
  priority: 'high' | 'medium' | 'low';
  actionLabel?: string;
  actionLink?: string;
}

export const mockSuggestions: Suggestion[] = [
  {
    id: 's1',
    type: 'insight',
    title: 'Stay on Track',
    description: "You're 45% through your New Mom journey. Keep up the great work!",
    icon: 'trending-up',
    priority: 'high',
  },
  {
    id: 's2',
    type: 'action',
    title: 'Book Your Ultrasound',
    description: 'Your 12-week scan is recommended. We found 3 network clinics near you.',
    icon: 'local-hospital',
    priority: 'high',
    actionLabel: 'View Clinics',
    actionLink: '/journey/new-mom/clinics',
  },
  {
    id: 's3',
    type: 'offer',
    title: 'Education Planning',
    description: "Start planning for your child's future with AIA Education Plus",
    icon: 'school',
    priority: 'medium',
    actionLabel: 'Learn More',
    actionLink: '/benefits/education',
  },
  {
    id: 's4',
    type: 'insight',
    title: 'Health Tip',
    description: 'Prenatal yoga can help reduce stress. Check out our wellness programs.',
    icon: 'self-improvement',
    priority: 'low',
    actionLabel: 'Explore Programs',
    actionLink: '/benefits/wellness',
  },
];
